import { Market } from '@shared/config/market/market.models';
import { stenaAssets } from '@shared/config/market/market.assets';

export const stenaSwedishCompanyData: Market = {
    number: 101,
    domain: 'sembo.stenaline.se',
    isSubdomain: true,
    locale: 'sv',
    fullLocale: 'sv-SE',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.se',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.se',
            },
            {
                text: 'Om Stena Line',
                href: '/kundservice',
            },
            {
                text: 'Regler & policies',
                href: '/legal/resevillkor',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'SEK',
        currencySymbol: 'kr',
    },
};

export const stenaNorwegianCompanyData: Market = {
    number: 104,
    domain: 'sembo.stenaline.no',
    isSubdomain: true,
    locale: 'no',
    fullLocale: 'nb-NO',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.no',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.no',
            },
            {
                text: 'Om Stena Line',
                href: '/om-stena-line',
            },
            {
                text: 'Regler & policies',
                href: 'https://www.sembo.no/pages/terms?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'NOK',
        currencySymbol: 'kr',
    },
};

export const stenaDanishCompanyData: Market = {
    number: 105,
    domain: 'sembo.stenaline.dk',
    isSubdomain: true,
    locale: 'da',
    fullLocale: 'da-DK',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.dk',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.dk',
            },
            {
                text: 'Om Stena Line',
                href: '/om-stenaline',
            },
            {
                text: 'Regler & Politikker',
                href: 'https://www.dtf-travel.dk/pages/terms-dtf.aspx?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: ',',
        currency: 'DKK',
        currencySymbol: 'kr',
    },
};

export const stenaFinnishCompanyData: Market = {
    number: 106,
    domain: 'sembo.stenaline.fi',
    isSubdomain: true,
    locale: 'fi',
    fullLocale: 'fi-FI',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.fi',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.fi',
            },
            {
                text: 'Tietoja Stena Line',
                href: '/tietoja-stena-line',
            },
            {
                text: 'Säännöt & käytännöt',
                href: 'https://www.sembo.fi/pages/terms?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const stenaGermanCompanyData: Market = {
    number: 107,
    domain: 'sembo.stenaline.de',
    isSubdomain: true,
    locale: 'de',
    fullLocale: 'de-DE',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.de',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.de',
            },
            {
                text: 'Über Stena Line',
                href: '/impressum/unternehmen',
            },
            {
                text: 'Regeln & Richtlinien',
                href: 'https://www.sembo.de/pages/terms?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const stenaPolishCompanyData: Market = {
    number: 108,
    domain: 'sembo.stenaline.pl',
    isSubdomain: true,
    locale: 'pl',
    fullLocale: 'pl-PL',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.pl',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.pl',
            },
            {
                text: 'O Stena Line',
                href: '/o-stena-line',
            },
            {
                text: 'Regulacje i warunki świadczenia usług',
                href: 'https://www.sembo.pl/pages/terms.aspx?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'PLN',
        currencySymbol: 'zł',
    },
};

export const stenaDutchCompanyData: Market = {
    number: 109,
    domain: 'sembo.stenaline.nl',
    isSubdomain: true,
    locale: 'nl',
    fullLocale: 'nl-NL',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.nl',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.nl',
            },
            {
                text: 'Over Stena Line',
                href: 'https://www.sembo.se/om-oss',
            },
            {
                text: 'Regels & beleid',
                href: 'https://www.sembo.nl/pages/terms.aspx?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};

export const stenaBritishCompanyData: Market = {
    number: 110,
    domain: 'sembo.stenaline.co.uk',
    isSubdomain: true,
    locale: 'en',
    fullLocale: 'en-GB',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.co.uk',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.co.uk',
            },
            {
                text: 'About Stena Line',
                href: '/about-stena-line',
            },
            {
                text: 'Regulations & policies',
                href: 'https://www.sembo.co.uk/pages/terms?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'GBP',
        currencySymbol: '£',
    },
};

export const stenaIrishCompanyData: Market = {
    number: 111,
    domain: 'sembo.stenaline.ie',
    isSubdomain: true,
    locale: 'en',
    fullLocale: 'en-IE',
    name: 'StenaLine',
    homePage: 'https://www.stenaline.ie',
    copyright: 'Stena Line',
    assets: stenaAssets,
    footerInfo: [
        [
            {
                text: `© ${new Date().getFullYear()} Stena Line`,
                href: 'https://www.stenaline.ie',
            },
            {
                text: 'About Stena Line',
                href: '/about-stena-line',
            },
            {
                text: 'Regulations & policies',
                href: 'https://www.sembo.ie/pages/terms?packageterms=true',
            },
        ],
    ],
    moneyFormat: {
        numberOfDecimals: 2,
        decimalSeparator: '.',
        currency: 'EUR',
        currencySymbol: '€',
    },
};
